/* eslint-disable @typescript-eslint/no-shadow */
import { Yup } from 'shared/lib'

const validTaxID =
   /^(?:\d{10}|[1-9][0-9]{6,8}|[1-9]\d{8}|[1-9]\d{7,9}|ATU\d{8}|CHE-\d{3}\.\d{3}\.\d{3}(?:\s(?:MWST|TVA|IVA))?)$/

const validCompanyName =
   /^([a-zA-Z0-9żźćńółęąśŻŹŚŁĆŃÓĘĄäÄöÖüÜßÁČĎÉĚChÍŇÓŘŠŤÚŮÝŽáčďéěchíňóřštúůýžèàìòùç"'„”.,\-/:~!@#$%^&*()_+=[\]{}|<>?`\\][\s]*)*\s*['"]?$/

const validPostCode = /^(?:[A-Za-z]{2})?(?:\d{4}|\d{5}|\d{6}|\d{2}-\d{3}|\d{3}\s?\d{2})$/
const validCity =
   /^([a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄäÄöÖüÜßẞÁČĎÉĚèàìòùçChÍŇÓŘŠŤÚŮÝŽáčďéěèàìòùçchíňóřštúůýž'-]\s?)*([^\s\d][a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄäÄöÖüÜßẞÁČĎÉĚèàìòùçChÍŇÓŘŠŤÚŮÝŽáčďéěèàìòùçchíňóřštúůýž])$/

export const schema = Yup.object()
   .shape({
      companyName: Yup.string().matches(validCompanyName, 'validation.companyNamePattern').nullable(),
      surname: Yup.string().nullable(),
      name: Yup.string().nullable(),
      email: Yup.string(),
      contacts: Yup.array().of(
         Yup.object().shape({
            name: Yup.string(),
            surname: Yup.string(),
            description: Yup.string(),
            email: Yup.string(),
            phoneNumber: Yup.string(),
         })
      ),
      taxID: Yup.string().matches(validTaxID, 'validation.taxIdPattern').nullable(),
      address: Yup.object().shape({
         street: Yup.string(),
         houseNumber: Yup.string(),
         zipCode: Yup.string().matches(validPostCode, 'validation.postCodePattern'),
         city: Yup.string().matches(validCity, 'validation.cityPattern'),
         voivodeship: Yup.string(),
         county: Yup.string(),
         country: Yup.string(),
      }),
      deliveryAddresses: Yup.array().of(
         Yup.object().shape({
            street: Yup.string(),
            houseNumber: Yup.string(),
            zipCode: Yup.string().matches(validPostCode, 'validation.postCodePattern'),
            city: Yup.string().matches(validCity, 'validation.cityPattern'),
            voivodeship: Yup.string(),
            county: Yup.string(),
            country: Yup.string(),
         })
      ),
      deliveryType: Yup.string().nullable(),
      paymentMethod: Yup.string().nullable(),
      description: Yup.string().nullable(),
   })
   .test('company-or-person', 'validation.companyOrPersonRequired', (value) => {
      if (!value) return false

      const hasCompany = !!value.companyName && !!value.taxID

      const hasPerson = !!value.name && !!value.surname

      return hasCompany || hasPerson
   })

export const vehicleSchema = Yup.object().shape({
   model: Yup.string().nullable(),
   brand: Yup.string().nullable(),
   productionYear: Yup.string().nullable(),
   description: Yup.string().nullable(),
   engine: Yup.string().nullable(),
   vin: Yup.string().nullable(),
   registrationNumber: Yup.string().required(),
})
